import { FC } from 'react';
import { IconProps } from 'react-toastify';

import { ReactComponent as ExclamationCircleIcon } from 'assets/icons/ExclamationCircleIcon.svg';

import scssVariables from 'styles/sass-variables.module.scss';

export const InactivityIcon: FC<IconProps> = () => {
  return (
    <ExclamationCircleIcon fill={scssVariables.orange_600} />
  );
};
